/**
 * Deploy-time configuration, read at page load rather than baked into the bundle.
 *
 * One image serves every brand and environment of a branch: the container
 * writes `/config.js` from its environment on start (see
 * `docker/40-runtime-config.sh`), which sets `window.__ENV__` before the
 * bundle runs. `process.env` is the fallback, so `.env` files keep working for
 * `pnpm start` and Jest, where no `config.js` is generated.
 */
declare global {
    interface Window {
        __ENV__?: Record<string, string | undefined>;
    }
}

export function env(key: string): string | undefined {
    const value = window.__ENV__?.[key];
    // The container substitutes an unset variable as "", which must fall
    // through to the build-time value rather than override it with nothing.
    return value != null && value !== "" ? value : process.env[key];
}
